export * from './lib/loading.component';
